import { render, staticRenderFns } from "./ZoneGroup.vue?vue&type=template&id=20b5b250&scoped=true"
import script from "./ZoneGroup.vue?vue&type=script&lang=js"
export * from "./ZoneGroup.vue?vue&type=script&lang=js"
import style0 from "./ZoneGroup.vue?vue&type=style&index=0&id=20b5b250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b5b250",
  null
  
)

export default component.exports